import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import type { RecordStatus } from '../../../hooks/useRecordById'
import { Button, ErrorMessage, FormActions } from '../../atoms'

interface FormLoadStateProps {
  status: Exclude<RecordStatus, 'new' | 'ready' | 'loading'>
  onClose: () => void
}

// What a form shows when its record can't be loaded (forms show their own skeleton while loading)
export const FormLoadState = memo(({ status, onClose }: FormLoadStateProps) => {
  const { t } = useTranslation('admin-mobifull')
  return (
    <div className="form-load-state" role="alert">
      <ErrorMessage
        message={status === 'missing' ? t('common.recordNotFound') : t('common.error')}
      />
      <FormActions>
        <Button type="button" variant="secondary" onClick={onClose}>
          {t('common.actions.cancel')}
        </Button>
      </FormActions>
    </div>
  )
})

FormLoadState.displayName = 'FormLoadState'
